import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import './style.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Cursor circle effect
    const cursor = document.createElement('div');
    cursor.classList.add('cursor-circle');
    document.body.appendChild(cursor);

    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;

    const animate = () => {
      currentX += (mouseX - currentX) * 0.1;
      currentY += (mouseY - currentY) * 0.1;
      cursor.style.left = `${currentX}px`;
      cursor.style.top = `${currentY}px`;
      requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    animate();

    return () => {
      document.body.removeChild(cursor);
    };
  }, []);

  // 🛩️ Flying images (bottom to top)
  useEffect(() => {
    const imageList = [
      'flying_img/flying1.jpg',
      'flying_img/flying2.jpg',
      'flying_img/flying3.jpg',
      'flying_img/flying4.jpg',
      'flying_img/flying5.jpg'
    ];

    const interval = setInterval(() => {
      const img = document.createElement('img');
      img.src = imageList[Math.floor(Math.random() * imageList.length)];
      img.className = 'flying-image';

      const leftPosition = Math.random() * (window.innerWidth - 100);
      img.style.left = `${leftPosition}px`;

      document.body.appendChild(img);

      img.addEventListener('animationend', () => {
        img.remove();
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <div className="light-mode" id="root-container">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <div className="floating-circle"></div>
      </div>

      {/* Blurred Background Circles */}
      <div className="background-blur-container">
        <div className="blurred-circle circle1"></div>
        <div className="blurred-circle circle2"></div>
        <div className="blurred-circle circle3"></div>
      </div>
    </Router>
  );
}

export default App;
